export default {
  wrapper: {
    position: 'relative',
    height: 'calc(100vh - 160px)',
  },
};
